import { Skeleton } from '@mui/material';
import { useEffect } from 'react';
import { messagesRequests } from 'redux/requests/messages.requests';
import { useApiCall } from 'redux/utils/api-hook';
import { Template } from './templates-display';
import { MustacheTemplateVariablesDto } from '@act/shared/data-transfer-objects';

interface SuggestedTemplatesDisplayProps {
  handleApplyTemplate: (
    templateString: string,
    templateVariables: MustacheTemplateVariablesDto
  ) => void;
  templateVariables: MustacheTemplateVariablesDto;
  memberId: string;
}

const SuggestedTemplatesDisplay = ({
  handleApplyTemplate,
  memberId,
  templateVariables,
}: SuggestedTemplatesDisplayProps) => {
  const [suggestionResponse, isLoading, getMessageSuggestions] = useApiCall(
    messagesRequests.getMessageSuggestions
  );
  const suggestions = suggestionResponse?.textSuggestions
    ? [...suggestionResponse.textSuggestions]
    : [];
  useEffect(() => {
    if (memberId) {
      getMessageSuggestions({ params: { memberId } });
    }
  }, [memberId]);

  if (isLoading) {
    return (
      <Template>
        <Skeleton />
        <Skeleton />
        <Skeleton />
      </Template>
    );
  } else {
    return (
      <>
        {suggestions.map(s => {
          return (
            <Template
              key={s}
              onClick={() => handleApplyTemplate(s, templateVariables)}
            >
              {s}
            </Template>
          );
        })}
      </>
    );
  }
};

export default SuggestedTemplatesDisplay;
